import { render, staticRenderFns } from "./SimulationCard.vue?vue&type=template&id=367ea986&"
import script from "./SimulationCard.vue?vue&type=script&lang=js&"
export * from "./SimulationCard.vue?vue&type=script&lang=js&"
import style0 from "./SimulationCard.vue?vue&type=style&index=0&id=367ea986&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports